// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"CountryLanguageSwitcher_tooltip__2Jayd","box":"CountryLanguageSwitcher_box__3fXKd"};